import { useEffect, useState } from "react";

import FlightDetailsModal from "./FlightDetailsModal";

export default function FlightsModal({ onClose }) {

  const [flights, setFlights] = useState([]);

  const [loading, setLoading] = useState(true);
const handleDeleteFlight = async (flight) => {
    console.log("🗑 Delete Flight button clicked");

    if (!flight) {
        console.log("❌ No flight passed");
        return;
    }

    console.log("Selected Flight:", flight);

    const confirmed = window.confirm(
        "Delete this saved flight?"
    );

    if (!confirmed) {
        console.log("❌ User cancelled delete");
        return;
    }

    try {
        const token = localStorage.getItem("token");

        console.log("Token:", token);
        console.log("Deleting flight ID:", flight.id);

        const response = await fetch(
            `https://ficon-x.com/auth/delete-flight/${flight.id}`,
            {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        console.log("Response status:", response.status);

        const data = await response.json();

        console.log("Response data:", data);

        if (!response.ok || !data.success) {
            alert(data.message || data.error || "Unable to delete flight.");
            return;
        }

        console.log("✅ Flight deleted");

        // Remove the deleted flight from the list immediately
        setFlights(prevFlights =>
            prevFlights.filter(f => f.id !== flight.id)
        );

        alert("Flight deleted.");

    } catch (err) {
        console.error("Delete failed:", err);
        alert("Unable to contact server.");
    }
};

const [selectedFlight, setSelectedFlight] = useState(null);

  useEffect(() => {

    async function loadFlights() {

      try {

        const token = localStorage.getItem("token");

        const res = await fetch(
          "https://ficon-x.com/auth/get-flights",
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await res.json();

        setFlights(
          Array.isArray(data)
            ? data
            : data.flights || []
        );

      } catch (err) {

        console.error(err);

      } finally {

        setLoading(false);

      }

    }

    loadFlights();

  }, []);

  return (

    <div style={{

      position:"fixed",

      inset:0,

      background:"rgba(0,0,0,.65)",

      display:"flex",

      justifyContent:"center",

      alignItems:"center",

      zIndex:99999999

    }}>

      <div style={{

        width:"3000px",

        maxHeight:"85vh",

        marginTop: "50px", 

        overflowY:"auto",

        transform: "translateY(300px)",

        background:"#303640",

        border:"1px solid #5c6672",

        borderRadius:"14px",

        padding:"24px",

        color:"white"

      }}>

        <h2>

          ✈️ My Flights

        </h2>

        {loading && (

          <div>

            Loading...

          </div>

        )}

        {!loading && flights.length===0 && (

          <div>

            No saved flights.

          </div>

        )}

{/* ================================
    ACTIVE FLIGHT
================================ */}

<h3
  style={{
    marginTop: "20px",
    color: "#4caf50",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  }}
>
  🟢 Active Flight
</h3>

{!loading &&
  flights
    .filter(f => f.status === "ACTIVE")
    .map(f => (

      <div
        key={f.id}
        style={{
          padding:"14px",
          marginTop:"10px",
          border:"1px solid #4d5661",
          borderRadius:"10px",
          background:"#252b33"
        }}
      >

        <div>
          <b>
            {f.origin} → {f.destination}
          </b>
        </div>

        <div
          style={{
            marginTop:"6px",
            fontWeight:600,
            color:"#4caf50"
          }}
        >
          {f.status}
        </div>

        <div>
          {new Date(f.created_at).toLocaleString()}
        </div>

        <div
          style={{
            display:"flex",
            gap:"10px",
            marginTop:"14px"
          }}
        >

<button
onClick={() => {

    localStorage.setItem(
        "activeFlight",
        JSON.stringify(f.active_state)
    );

    window.location.reload();

}}
>
    Continue
</button>

          <button
            onClick={() => setSelectedFlight(f)}
          >
            Details
          </button>



        </div>

      </div>

))}

{/* ================================
    FLIGHT HISTORY
================================ */}

<h3 style={{ marginTop: "30px" }}>
  Completed Flights
</h3>

{!loading &&
  flights
    .filter(f => f.status === "COMPLETED")
    .map(f => (

      <div
        key={f.id}
        style={{
          padding:"14px",
          marginTop:"10px",
          border:"1px solid #4d5661",
          borderRadius:"10px",
          background:"#252b33"
        }}
      >

        <div>
          <b>
            {f.origin} → {f.destination}
          </b>
        </div>

        <div
          style={{
            marginTop:"6px",
            fontWeight:600,
            color:"#9e9e9e"
          }}
        >
          {f.status}
        </div>

        <div>
          {new Date(f.created_at).toLocaleString()}
        </div>

        <div
          style={{
            display:"flex",
            gap:"10px",
            marginTop:"14px"
          }}
        >

          <button
            onClick={() => setSelectedFlight(f)}
          >
            Details
          </button>

<button
  onClick={() => handleDeleteFlight(f)}
  style={{
    background: "#c62828",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    marginTop: "10px"
  }}
>
  Delete Flight
</button>
        </div>

      </div>

))}

        <button

          onClick={onClose}

          style={{

            marginTop:"20px",

            width:"100%",

            padding:"12px"

          }}

        >

          Close

        </button>

        

      </div>

      <FlightDetailsModal

    flight={selectedFlight}

    onClose={() => setSelectedFlight(null)}

/>

    </div>

  );

}